<script>
export default {
  translate25Context: "vrun_form",
  components: {},
  props: ["component", "handler"],
  data() {
    return {
      focused: false,
      opened: false,
      width: 0,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      listHeight: 200,
    };
  },
  methods: {
    open: function ($event) {
      if (this.opened) {
        this.opened = false;
        return;
      }
      setTimeout(() => {
        this.opened = true;
        this.positionOptions();

        setTimeout(() => {
          $(this.$el)
            .find(".f-vrun-form-lang-textfield-others input")
            .first()
            .focus();
        });
      });
    },
    positionOptions: function () {
      var space = 8;

      let $el = $(this.$el).find(".f-vrun-form-lang-textfield-default");

      let offset = $el.offset();

      this.top = "auto";
      this.left = offset.left + "px";
      this.bottom = "auto";
      this.right = "auto";
      this.width = $el.width() + "px";

      if (offset.top < $(window).height() - this.listHeight) {
        this.top = offset.top + $el.outerHeight() + space;
        this.top = this.top + "px";
      } else {
        this.bottom = $(window).height() - offset.top + space;
        this.bottom = this.bottom + "px";
      }
    },
    close: function () {
      this.opened = false;
    },
  },
  computed: {
    cssVars() {
      return {
        "--height": this._props.listHeight + "px",
        "--width": this.width,
        "--left": this.left,
        "--top": this.top,
        "--right": this.right,
        "--bottom": this.bottom,
      };
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.positionOptions);
  },
  destroyed() {
    window.addEventListener("resize", this.positionOptions);
  },
};
</script>

<template>
  <div class="f-vrun-form-lang-textfield">
    <f-field :focused="focused">
      <template v-slot:label>{{ $vt(component.title) }}</template>
      <template v-slot:content>
        <div class="f-vrun-form-lang-textfield-default">
          <div
            class="f-language-default f-languages-container"
            :class="{ focus: focused }"
          >
            <div class="f-language">
              {{ $vt(component.default.label) }}
              <input
                :value="component.default.value"
                @blur="
                  focused = false;
                  component.default.value = $event.target.value;
                  handler.action(component.default, 'set', [
                    $event.target.value,
                  ]);
                "
                @focus="focused = true"
              />
              <f-button
                class="more tertiary"
                type="icon"
                v-if="Object.values(component.others).length > 0"
                @click.stop="open($event)"
              >
                <div>
                  <f-icon icon="fa6-a"> </f-icon>
                  <f-icon icon="fa6-b"> </f-icon>
                  <f-icon icon="fa6-c"> </f-icon>
                </div>
              </f-button>
            </div>
          </div>
        </div>
        <div
          class="f-vrun-form-lang-textfield-others-container"
          v-if="opened"
          @wheel="close($event)"
        >
          <div
            class="f-vrun-form-lang-textfield-others"
            :style="cssVars"
            v-click-outside="close"
            @wheel.stop
          >
            <div
              class="f-language-user f-languages-container"
              v-for="language in component.others"
              :key="language['#id']"
            >
              <div class="f-language">
                {{ $vt(language.label) }}
                <input
                  :value="language.value"
                  @blur="
                    language.value = $event.target.value;
                    handler.action(language, 'set', [$event.target.value]);
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </f-field>
  </div>
</template>

<style scoped lang="scss">
.f-vrun-form-lang-textfield {
  .f-vrun-form-lang-textfield-others-container {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    .f-vrun-form-lang-textfield-others {
      display: flex;
      flex-direction: column;
      z-index: 1;
      background-color: white;
      box-shadow: 0px 8px 32px -8px rgba(22, 22, 21, 0.25);
      border-radius: 8px;
      padding: 8px;
      position: fixed;
      box-sizing: border-box;
      max-height: var(--height);
      left: var(--left);
      top: var(--top);
      right: var(--right);
      bottom: var(--bottom);
      width: var(--width);

      .f-language {
        border: none;
        background: none;
        &:hover {
          border: none;
        }
      }
    }
  }

  .f-languages-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;

    &.f-language-default {
      .more {
        cursor: pointer;
        padding: 0 8px;
        width: auto;
        font-size: 12px;

        > div {
          display: flex;
          gap: 0;
        }
      }
    }

    .f-language {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: "Lato";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: rgba(24, 24, 26, 0.5);
      width: 100%;
      height: 50px;
      padding: 4px;
      background: #f7f7f6;
      border-radius: 4px;
      border: 1px solid #bbbbb8;
      white-space: nowrap;
    }

    input {
      font-family: Raleway;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #161615;
      padding: 0;
      background: transparent;
      border: none;
      width: 100%;
      outline: 0;
      text-overflow: ellipsis;
      overflow-x: hidden;
      overflow-y: scroll;
      white-space: nowrap;

      &:active {
        outline: none;
        border: none;
        outline: 0;
      }

      &[readonly] {
        cursor: default;
      }
    }

    input[type="date"].f-input {
      overflow-y: initial;
    }

    input[type="number"].f-input::-webkit-outer-spin-button,
    input[type="number"].f-input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    textarea.f-input {
      white-space: inherit;
    }

    &:hover {
      .f-language {
        border: 1px solid rgba(24, 144, 211, 0.75);
      }
    }

    &.focus {
      .f-language {
        border: 1px solid #1890d3;
        outline: 5px solid rgba(24, 144, 211, 0.25);
      }
    }

    &.error {
      border-color: var(--statusNegative);
    }

    &.disabled {
      background: rgba(22, 22, 21, 0.05);
      border: 1px solid #bbbbb8;
      color: rgba(22, 22, 21, 0.25);

      &::placeholder {
        color: rgba(22, 22, 21, 0.25);
      }
    }
  }
}
.dark-mode {
  .f-vrun-form-lang-textfield {
    .f-vrun-form-lang-textfield-others-container {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      .f-vrun-form-lang-textfield-others {
        background-color: #000000;
        box-shadow: 0 12px 24px var(--white-a5);
        .f-language {
          border: none;
          &:hover {
            border: none;
          }

          &.focus {
            border: none;
            outline: none;
          }
        }
      }
    }

    .f-languages-container {
      .f-language {
        color: var(--white-a50);
        background: none;
        border: 1px solid var(--white-a25);
      }

      input {
        color: var(--white-a50);
      }

      &:hover {
        .f-language {
          border: 1px solid var(--navigation-a50);
        }
      }

      &.focus {
        .f-language {
          border: 1px solid var(--navigation);
          outline: 5px solid var(--navigation-a25);
        }
      }

      &.error {
        border-color: var(--negative);
      }

      &.disabled {
        background: var(--white-a5);
        border: 1px solid var(--white-a10);
        color: var(--white-a10);

        &::placeholder {
          color: var(--white-a10);
        }
      }
    }
  }
}
</style>